import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from '@chakra-ui/react';
import { useState } from 'react';

import { CreationsBody, CreationsFooter } from './creations';
import {
  SetUpYourProfile1Body,
  SetUpYourProfile1Footer,
} from './set-up-your-profile-1';
import {
  SetUpYourProfile2Body,
  SetUpYourProfile2Footer,
} from './set-up-your-profile-2';
import {
  SetUpYourProfile3Body,
  SetUpYourProfile3Footer,
} from './set-up-your-profile-3';
import {
  SetUpYourProfile4Body,
  SetUpYourProfile4Footer,
} from './set-up-your-profile-4';
import {
  SetUpYourProfile5Body,
  SetUpYourProfile5Footer,
} from './set-up-your-profile-5';

const SetUpYourProfile = ({ modal }: { modal: any }) => {
  const [tutorialModalContent, setTutorialModalContent] = useState('creations');

  return (
    <>
      <Modal
        isOpen={modal.isOpen}
        onClose={() => {
          modal.onClose();
          modal.openChecklistModal();
          setTutorialModalContent('creations');
        }}
        isCentered
      >
        <ModalOverlay />
        <ModalContent maxW="800px">
          <ModalCloseButton color="gray.500" />
          <ModalBody px="60px" pt="40px" pb="24px" bg="white">
            {tutorialModalContent === 'creations' && <CreationsBody />}
            {tutorialModalContent === 'setUpYourProfile1' && (
              <SetUpYourProfile1Body />
            )}
            {tutorialModalContent === 'setUpYourProfile2' && (
              <SetUpYourProfile2Body />
            )}
            {tutorialModalContent === 'setUpYourProfile3' && (
              <SetUpYourProfile3Body />
            )}
            {tutorialModalContent === 'setUpYourProfile4' && (
              <SetUpYourProfile4Body />
            )}
            {tutorialModalContent === 'setUpYourProfile5' && (
              <SetUpYourProfile5Body />
            )}
          </ModalBody>
          <ModalFooter
            flexDirection="column"
            alignItems="center"
            bg="gray.100"
            px="60px"
            py="25px"
          >
            {tutorialModalContent === 'creations' && (
              <CreationsFooter setNextModal={setTutorialModalContent} />
            )}
            {tutorialModalContent === 'setUpYourProfile1' && (
              <SetUpYourProfile1Footer setNextModal={setTutorialModalContent} />
            )}
            {tutorialModalContent === 'setUpYourProfile2' && (
              <SetUpYourProfile2Footer setNextModal={setTutorialModalContent} />
            )}
            {tutorialModalContent === 'setUpYourProfile3' && (
              <SetUpYourProfile3Footer setNextModal={setTutorialModalContent} />
            )}
            {tutorialModalContent === 'setUpYourProfile4' && (
              <SetUpYourProfile4Footer setNextModal={setTutorialModalContent} />
            )}
            {tutorialModalContent === 'setUpYourProfile5' && (
              <SetUpYourProfile5Footer
                completed={modal.completed}
                closeModal={() => {
                  modal.onClose();
                  modal.openChecklistModal();
                  setTutorialModalContent('creations');
                }}
              />
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default SetUpYourProfile;
